module.exports = __webpack_public_path__ + "img/no_jiangping.a6f961c7.png";